import { useObservable } from "micro-observables";
import React from "react";
import styled from "styled-components";
import { TimeIcon } from "@ui/components/icons";
import { useEditorController } from "@ui/pages/lms/courseEditorPage/courseEditorController/editorControllerContext";

type DurationEditorProps = React.LabelHTMLAttributes<HTMLLabelElement>;

export const DurationEditor: React.FC<DurationEditorProps> = ({ ...htmlProps }) => {
	const controller = useEditorController();
	const course = useObservable(controller.course);

	return (
		<Container htmlFor="duration" {...htmlProps}>
			<TimeIcon />
			<input
				id="duration"
				name="duration"
				type="number"
				min={0}
				value={course.duration + ""}
				onChange={(e) =>
					!isNaN(+e.currentTarget.value) &&
					+e.currentTarget.value < 6000 &&
					controller.setDuration(+e.currentTarget.value)
				}
			/>
			<span>min*</span>
		</Container>
	);
};

const Container = styled.label`
	${({ theme }) => theme.containerStyles.roundedBlockStyle};
	padding: 10px 16px;
	display: flex;
	align-items: center;
	cursor: pointer;

	svg {
		width: 20px;
		height: 20px;
		margin-right: 10px;
	}

	input {
		width: 50px;
		border: none;
		outline: none;
	}
`;
